import { deleteDoc,doc } from 'firebase/firestore'  
import { db } from './firebase-config';



export  async  function DeleteData(dataName,id) {
 const dataRef =  doc(db,dataName,id)
await deleteDoc(dataRef)
return true

} 